import { render, staticRenderFns } from "./NavSideBar.vue?vue&type=template&id=3ed54dba&scoped=true&"
import script from "./NavSideBar.vue?vue&type=script&lang=js&"
export * from "./NavSideBar.vue?vue&type=script&lang=js&"
import style0 from "./NavSideBar.vue?vue&type=style&index=0&id=3ed54dba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed54dba",
  null
  
)

export default component.exports